var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: ["daily-schedule", _vm.isGroup ? "group" : ""],
      attrs: { fluid: "" }
    },
    [
      [
        _c(
          "v-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "portal",
              { attrs: { to: "page-title" } },
              [
                _vm.$vuetify.breakpoint.mdAndDown
                  ? [
                      _c(
                        "v-container",
                        { staticClass: "schedule-header py-0 mx-0" },
                        [
                          _c(
                            "v-row",
                            { attrs: { justify: "space-between" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-1",
                                  attrs: {
                                    "align-self": "center",
                                    cols: "auto"
                                  }
                                },
                                [
                                  _c("v-select", {
                                    staticClass:
                                      "daily-schedule-picker subtitle-2",
                                    style: _vm.selectorsStyle,
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      "item-text": "name",
                                      "item-value": "id",
                                      items: _vm.dailyScheduleTypes,
                                      "menu-props": {
                                        top: false,
                                        offsetY: true
                                      },
                                      outlined: "",
                                      "return-object": ""
                                    },
                                    on: {
                                      change: _vm.onDailyScheduleTypeChange
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function(ref) {
                                            var attrs = ref.attrs
                                            var item = ref.item
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-list-item",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "daily-schedule-item"
                                                    },
                                                    "v-list-item",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(item.name) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3194219055
                                    ),
                                    model: {
                                      value: _vm.activeDailyScheduleType,
                                      callback: function($$v) {
                                        _vm.activeDailyScheduleType = $$v
                                      },
                                      expression: "activeDailyScheduleType"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-0",
                                  attrs: {
                                    "align-self": "center",
                                    cols: "auto"
                                  }
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ml-1",
                                      attrs: { align: "center" }
                                    },
                                    [
                                      _c("DepartmentGroupSelector", {
                                        style: _vm.selectorsStyle
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.$vuetify.breakpoint.width <=
                              _vm.ELLIPSIS_BREAKPOINT
                                ? [
                                    _c("v-spacer"),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          "align-self": "center",
                                          cols: "auto"
                                        }
                                      },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "min-width": "200",
                                              "offset-y": true
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "mx-1 account-icon",
                                                            attrs: {
                                                              icon: "",
                                                              small: ""
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "\n                          fal fa-ellipsis-v\n                        "
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1407316930
                                            )
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: _vm.toggleHelpPanel
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-action",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { small: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            fal fa-info-circle\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "labels.information"
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : [_c("v-spacer")],
                              !_vm.isGroup && _vm.$vuetify.breakpoint.lgAndUp
                                ? [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          "align-self": "center",
                                          cols: "auto"
                                        }
                                      },
                                      [
                                        _c("portal-target", {
                                          attrs: {
                                            name: "daily-schedule-state"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("v-spacer")
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  : [
                      _c(
                        "v-row",
                        {
                          staticClass: "schedule-header",
                          attrs: { justify: "space-between" }
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { "align-self": "center", cols: "auto" } },
                            [
                              _c("v-select", {
                                staticClass: "daily-schedule-picker subtitle-2",
                                staticStyle: { "max-width": "200px" },
                                attrs: {
                                  dense: "",
                                  "hide-details": "",
                                  "item-text": "name",
                                  "item-value": "id",
                                  items: _vm.dailyScheduleTypes,
                                  "menu-props": { top: false, offsetY: true },
                                  outlined: "",
                                  "return-object": ""
                                },
                                on: { change: _vm.onDailyScheduleTypeChange },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function(ref) {
                                      var attrs = ref.attrs
                                      var item = ref.item
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-list-item",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "daily-schedule-item"
                                              },
                                              "v-list-item",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.name) +
                                                      "\n                      "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.activeDailyScheduleType,
                                  callback: function($$v) {
                                    _vm.activeDailyScheduleType = $$v
                                  },
                                  expression: "activeDailyScheduleType"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { "align-self": "center", cols: "auto" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ml-1",
                                  attrs: { align: "center" }
                                },
                                [_c("DepartmentGroupSelector")],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-spacer"),
                          !_vm.isGroup
                            ? [
                                _c(
                                  "v-col",
                                  {
                                    attrs: {
                                      "align-self": "center",
                                      cols: "auto"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ml-1",
                                        attrs: { align: "center" }
                                      },
                                      [
                                        _c("portal-target", {
                                          attrs: {
                                            name: "daily-schedule-state"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("v-spacer")
                              ]
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              staticClass: "pr-0",
                              attrs: { "align-self": "center", cols: "auto" }
                            },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", "nudge-top": "10" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var tooltipOn = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mx-1",
                                                  attrs: { icon: "" }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              Object.assign({}, tooltipOn, {
                                                click: _vm.toggleHelpPanel
                                              })
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                      fal fa-info-circle\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.information")) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ]
              ],
              2
            ),
            _c(
              "v-container",
              { staticClass: "body-container actions", attrs: { fluid: "" } },
              [
                _c(
                  "v-row",
                  {
                    style: [
                      _vm.$vuetify.breakpoint.smAndDown
                        ? { "text-align": "center" }
                        : {}
                    ],
                    attrs: { align: "center", "no-gutters": "" }
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "date-navigation subtitle-2 font-weight-medium primary--text text-no-wrap",
                        attrs: { cols: "12", sm: "auto" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm
                                  .moment(_vm.date)
                                  .format(_vm.dateFormatString)
                              ) +
                              "\n            "
                          )
                        ]),
                        _c(
                          "v-btn",
                          {
                            staticClass: "grey--text text--darken-3 mb-1",
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.loadNewContent(_vm.previousDay)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "primary", size: "16" } },
                              [
                                _vm._v(
                                  "\n                far fa-chevron-left\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-menu",
                          {
                            ref: "datePicker",
                            attrs: {
                              "close-on-content-click": false,
                              transition: "scale-transition",
                              "offset-y": "",
                              "max-width": "290px",
                              "min-width": "290px"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "primary--text mb-1",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "gray", size: "18" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    far fa-calendar-day\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.showDatePicker,
                              callback: function($$v) {
                                _vm.showDatePicker = $$v
                              },
                              expression: "showDatePicker"
                            }
                          },
                          [
                            _c(
                              "v-date-picker",
                              {
                                attrs: { value: _vm.date },
                                on: {
                                  change: function(newDate) {
                                    return _vm.loadNewContent(_vm.setDate, [
                                      newDate
                                    ])
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      disabled: _vm.date === _vm.today,
                                      outlined: "",
                                      small: ""
                                    },
                                    on: { click: _vm.goToToday }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.today")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "grey--text text--darken-3 mb-1",
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.loadNewContent(_vm.nextDay)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "primary", size: "16" } },
                              [
                                _vm._v(
                                  "\n                far fa-chevron-right\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "share mb-1 ml-6",
                            attrs: {
                              color: "secondary",
                              text: _vm.$vuetify.breakpoint.lgAndUp,
                              icon: _vm.$vuetify.breakpoint.mdAndDown,
                              title: _vm.$t("labels.share")
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.shareDialogOpened = true
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { size: "20" } }, [
                              _vm._v(
                                "\n                fas fa-share-alt\n              "
                              )
                            ]),
                            _vm.$vuetify.breakpoint.lgAndUp
                              ? _c("span", { staticClass: "ml-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("labels.share")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        !_vm.isGroup
                          ? _c("portal-target", {
                              attrs: {
                                name: "daily-schedule-finalize",
                                slim: ""
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("v-spacer"),
                    _c("v-col", { attrs: { cols: "12", sm: "auto" } }, [
                      _c(
                        "div",
                        {
                          class: [
                            "actions",
                            _vm.$vuetify.breakpoint.smAndDown
                              ? ""
                              : "float-right"
                          ]
                        },
                        [
                          !_vm.isGroup
                            ? _c("portal-target", {
                                attrs: {
                                  name: "daily-schedule-actions",
                                  slim: ""
                                }
                              })
                            : _vm._e(),
                          _vm.$can("view", "openShift")
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-badge",
                                              {
                                                staticClass:
                                                  "badge-panel count",
                                                attrs: {
                                                  avatar: "",
                                                  color: "error",
                                                  content: _vm.openShiftCount,
                                                  overlap: "",
                                                  value: _vm.openShiftCount > 0
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        class:
                                                          _vm.actionStyles
                                                            .viewOpenShift
                                                            .button.classes,
                                                        attrs: {
                                                          icon: "",
                                                          value: "viewOpenShift"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setPanelName(
                                                              "viewOpenShift"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        class:
                                                          _vm.actionStyles
                                                            .viewOpenShift.icon
                                                            .classes,
                                                        attrs: { size: "16" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        fal fa-list\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1096775995
                                  )
                                },
                                [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.viewOpenShift")) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              class:
                                                _vm.actionStyles.filters.button
                                                  .classes,
                                              attrs: {
                                                icon: "",
                                                value: "filters"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setPanelName(
                                                    "filters"
                                                  )
                                                }
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm.hasFilters &&
                                          _vm.pagePanelName !== "filters"
                                            ? _c(
                                                "v-icon",
                                                {
                                                  class:
                                                    _vm.actionStyles.filters
                                                      .icon.classes,
                                                  attrs: { size: "16" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      fas fa-filter\n                    "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "v-icon",
                                                {
                                                  class:
                                                    _vm.actionStyles.filters
                                                      .icon.classes,
                                                  attrs: { size: "16" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      fal fa-filter\n                    "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("span", { staticClass: "body-2" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("labels.filter")) +
                                    "\n                "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-container",
              { staticClass: "body-container pa-0", attrs: { fluid: "" } },
              [
                _c(
                  "div",
                  { class: ["department-columns", _vm.isGroup ? "group" : ""] },
                  _vm._l(_vm.activeDepartments, function(department) {
                    return _c("DepartmentDailySchedule", {
                      key: department.id + "-" + _vm.isGroup,
                      ref: "columns",
                      refInFor: true,
                      attrs: {
                        compact: _vm.isGroup,
                        "daily-schedule-type": _vm.confirmedDailyScheduleType,
                        date: _vm.date,
                        "department-data":
                          _vm.departmentData[department.id] || null,
                        "department-id": department.id,
                        filters: _vm.filters,
                        "load-data": false,
                        "show-skeleton-loader": _vm.showSkeletonLoader
                      }
                    })
                  }),
                  1
                )
              ]
            ),
            _c(
              "v-dialog",
              {
                attrs: { persistent: "", width: "500" },
                model: {
                  value: _vm.shareDialogOpened,
                  callback: function($$v) {
                    _vm.shareDialogOpened = $$v
                  },
                  expression: "shareDialogOpened"
                }
              },
              [
                _c(
                  "v-card",
                  { attrs: { id: "shareScheduleDialog" } },
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "primary--text subtitle-2 py-2" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("labels.share")) +
                            "\n            "
                        ),
                        _c("v-spacer"),
                        _vm.sharingSummaryState !==
                        _vm.SHARING_SUMMARY_IN_PROGRESS
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "float-right",
                                attrs: { icon: "", "x-small": "" },
                                on: {
                                  click: function($event) {
                                    _vm.shareDialogOpened = false
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fal fa-times")])],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("v-divider", { staticClass: "mx-2" }),
                    _vm.loadingShareDialog
                      ? [
                          _c(
                            "v-row",
                            {
                              staticStyle: { height: "540px" },
                              attrs: { align: "center" }
                            },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "v-col",
                                        { staticClass: "text-center" },
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              color: "info",
                                              indeterminate: "",
                                              size: "75",
                                              width: "6"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { staticClass: "text-center" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("descriptions.loading")
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-spacer")
                            ],
                            1
                          )
                        ]
                      : [
                          _c(
                            "v-card-text",
                            { staticClass: "mt-4 pb-0" },
                            [
                              _c("div", { staticClass: "body-2" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("descriptions.shareSummary")
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _c("br"),
                              _c(
                                "v-card",
                                {
                                  staticClass: "px-0 lighten-5",
                                  attrs: { color: "grey", outlined: "" }
                                },
                                [
                                  _c("v-data-table", {
                                    staticClass: "share-list mx-4",
                                    attrs: {
                                      dense: "",
                                      "fixed-header": "",
                                      headers: _vm.shareSummaryHeaders,
                                      height: "400",
                                      "hide-default-footer": "",
                                      items: _vm.shareWithDepartments,
                                      "items-per-page":
                                        _vm.shareWithDepartments.length,
                                      "mobile-breakpoint": "",
                                      "single-select": ""
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "header.dailySchedule",
                                        fn: function(ref) {
                                          var header = ref.header
                                          return [
                                            _vm.shareCount[header.id] ===
                                            _vm.shareWithDepartments.length
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.sharingSummaryState ===
                                                        _vm.SHARING_SUMMARY_IN_PROGRESS,
                                                      icon: "",
                                                      ripple: false,
                                                      height: "12",
                                                      width: "12"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.shareWithZeroDepartments(
                                                          header.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "info",
                                                          size: "14"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        fas fa-check-square\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm.shareCount[header.id] > 0
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.sharingSummaryState ===
                                                        _vm.SHARING_SUMMARY_IN_PROGRESS,
                                                      icon: "",
                                                      ripple: false,
                                                      height: "12",
                                                      width: "12"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.shareWithZeroDepartments(
                                                          header.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "info",
                                                          size: "14"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        fas fa-minus-square\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.sharingSummaryState ===
                                                        _vm.SHARING_SUMMARY_IN_PROGRESS,
                                                      icon: "",
                                                      ripple: false,
                                                      height: "12",
                                                      width: "12"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.shareWithAllDepartments(
                                                          header.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { size: "14" } },
                                                      [
                                                        _vm._v(
                                                          "\n                        fal fa-square\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey--text text--darken-3 ml-2",
                                                style: {
                                                  cursor:
                                                    _vm.sharingSummaryState !==
                                                    _vm.SHARING_SUMMARY_IN_PROGRESS
                                                      ? "pointer"
                                                      : ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.shareCount[header.id] >
                                                    0
                                                      ? _vm.shareWithZeroDepartments(
                                                          header.id
                                                        )
                                                      : _vm.shareWithAllDepartments(
                                                          header.id
                                                        )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("labels.selectAll")
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "item.department",
                                        fn: function(ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey--text text--darken-3 dept-name d-inline-block text-truncate",
                                                attrs: { title: item.name }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            item.status === "pending"
                                              ? _c("v-progress-linear", {
                                                  staticClass: "share-progress",
                                                  attrs: {
                                                    color: "nb-azure",
                                                    rounded: "",
                                                    value: "100"
                                                  }
                                                })
                                              : item.status === "in_progress"
                                              ? _c("v-progress-linear", {
                                                  staticClass: "share-progress",
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "secondary",
                                                    rounded: ""
                                                  }
                                                })
                                              : item.status === "success"
                                              ? [
                                                  _c("v-progress-linear", {
                                                    staticClass:
                                                      "share-progress",
                                                    attrs: {
                                                      color: "secondary",
                                                      rounded: "",
                                                      value: "100"
                                                    }
                                                  }),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "ml-1 share-progress-status",
                                                      attrs: {
                                                        color: "secondary",
                                                        size: "10"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        far fa-check\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : item.status === "failed"
                                              ? [
                                                  _c("v-progress-linear", {
                                                    staticClass:
                                                      "share-progress",
                                                    attrs: {
                                                      color: "error",
                                                      rounded: "",
                                                      value: "100"
                                                    }
                                                  }),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "ml-1 share-progress-status",
                                                      attrs: {
                                                        color: "error",
                                                        size: "10"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        far fa-exclamation-triangle\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        }
                                      },
                                      {
                                        key: "item.dailySchedule",
                                        fn: function(ref) {
                                          var header = ref.header
                                          var item = ref.item
                                          return [
                                            _c("v-simple-checkbox", {
                                              staticClass:
                                                "extra-dense-checkbox d-inline-block daily-schedule-check",
                                              attrs: {
                                                color: "info",
                                                disabled:
                                                  _vm.sharingSummaryState ===
                                                  _vm.SHARING_SUMMARY_IN_PROGRESS,
                                                ripple: false
                                              },
                                              model: {
                                                value:
                                                  item.dailySchedules[header.id]
                                                    .send,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.dailySchedules[
                                                      header.id
                                                    ],
                                                    "send",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.dailySchedules[header.id].send"
                                              }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "ml-2 grey--text text--darken-3 daily-schedule-label d-inline-block text-truncate",
                                                style: {
                                                  cursor:
                                                    _vm.sharingSummaryState !==
                                                    _vm.SHARING_SUMMARY_IN_PROGRESS
                                                      ? "pointer"
                                                      : ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleDailyScheduleShare(
                                                      item,
                                                      header
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(header.text) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "grey--text caption-2 mt-n2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      item.dailySchedules[
                                                        header.id
                                                      ].lastShared
                                                    ) +
                                                    "\n                      "
                                                ),
                                                item.dailySchedules[header.id]
                                                  .lastShared
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { right: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var on = ref.on
                                                                var attrs =
                                                                  ref.attrs
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticStyle: {
                                                                            "vertical-align":
                                                                              "inherit"
                                                                          },
                                                                          attrs: {
                                                                            color:
                                                                              "grey",
                                                                            size:
                                                                              "10"
                                                                          }
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            fal fa-info-circle\n                          "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-2"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  item
                                                                    .dailySchedules[
                                                                    header.id
                                                                  ]
                                                                    .lastSharedDetails
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c("EmployeeSelector", {
                                staticClass: "mt-4",
                                attrs: {
                                  disabled:
                                    _vm.sharingSummaryState ===
                                    _vm.SHARING_SUMMARY_IN_PROGRESS,
                                  filters: _vm.employeeSelectorFilter,
                                  hint: _vm.$t(
                                    "descriptions.emailAdditionalRecipients"
                                  ),
                                  label: _vm.$t(
                                    "labels.emailAdditionalRecipients"
                                  ),
                                  multiple: ""
                                },
                                on: { change: _vm.updateAdditionalRecipients }
                              }),
                              _vm.hasProps(
                                _vm.shareOptions,
                                "showNonDutyEmployees"
                              )
                                ? _c("v-checkbox", {
                                    staticClass: "extra-dense-checkbox mt-1",
                                    attrs: {
                                      color: "secondary",
                                      dense: "",
                                      label: _vm.$t(
                                        "labels.includeNonWorkingShifts"
                                      ),
                                      disabled:
                                        _vm.sharingSummaryState ===
                                        _vm.SHARING_SUMMARY_IN_PROGRESS
                                    },
                                    model: {
                                      value:
                                        _vm.shareOptions.showNonDutyEmployees,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.shareOptions,
                                          "showNonDutyEmployees",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "shareOptions.showNonDutyEmployees"
                                    }
                                  })
                                : _vm._e(),
                              _vm.shareWithAdditionalRecipients.status ===
                              "pending"
                                ? _c("v-progress-linear", {
                                    staticClass: "share-progress",
                                    attrs: {
                                      color: "nb-azure",
                                      rounded: "",
                                      value: "100"
                                    }
                                  })
                                : _vm.shareWithAdditionalRecipients.status ===
                                  "in_progress"
                                ? _c("v-progress-linear", {
                                    staticClass: "share-progress",
                                    attrs: {
                                      indeterminate: "",
                                      color: "secondary",
                                      rounded: ""
                                    }
                                  })
                                : _vm.shareWithAdditionalRecipients.status ===
                                  "success"
                                ? [
                                    _c("v-progress-linear", {
                                      staticClass: "share-progress",
                                      attrs: {
                                        color: "secondary",
                                        rounded: "",
                                        value: "100"
                                      }
                                    }),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass:
                                          "ml-1 share-progress-status",
                                        attrs: {
                                          color: "secondary",
                                          size: "10"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  far fa-check\n                "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm.shareWithAdditionalRecipients.status ===
                                  "failed"
                                ? [
                                    _c("v-progress-linear", {
                                      staticClass: "share-progress",
                                      attrs: {
                                        color: "error",
                                        rounded: "",
                                        value: "100"
                                      }
                                    }),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass:
                                          "ml-1 share-progress-status",
                                        attrs: { color: "error", size: "10" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  far fa-exclamation-triangle\n                "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "v-card-actions",
                            { staticClass: "px-6" },
                            [
                              _vm.failedSharingSummary
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "my-3 px-4 mr-1",
                                      attrs: { text: "" },
                                      on: { click: _vm.retryShareSummary }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("labels.retry")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "my-3 px-4 download-pdf",
                                  attrs: {
                                    color: "primary",
                                    disabled:
                                      !_vm.selectedDepartmentsToShare ||
                                      _vm.sharingSummaryState ===
                                        _vm.SHARING_SUMMARY_IN_PROGRESS,
                                    outlined: ""
                                  },
                                  on: { click: _vm.downloadSummary }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.downloadPDF")) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "my-3 px-4",
                                  attrs: {
                                    color: "accent",
                                    disabled:
                                      !_vm.selectedDepartmentsToShare ||
                                      _vm.sharingSummaryState ===
                                        _vm.SHARING_SUMMARY_IN_PROGRESS
                                  },
                                  on: { click: _vm.emailSummary }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.emailPDF")) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        ),
        _c("SidePanel", { attrs: { panels: _vm.sidePanels } })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }